/**
 * **Whether the day's plan stands beside the grid** — one viewer's choice, remembered in this
 * browser.
 *
 * Owner, 25 September 2026: the grid takes the whole width by default and the column comes out on
 * demand. A convenience, so it lives in `localStorage` and is read defensively: storage can throw
 * as well as answer `null`, and a value this build never wrote reads as the default, never as an
 * error. Opening a session shows the column for as long as the session is open, whatever is stored.
 *
 * Pure: no React, no DOM, no query hook, no i18next — the store arrives as a parameter.
 */

import type { PreferenceStore } from '~/shared/lib/preferenceStore';

const KEY = 'movebuddy.booking.dayPlan';
const SHOWN = 'shown';
const HIDDEN = 'hidden';

/** The column is hidden unless this viewer asked for it. */
export function readDayPlanShown(store: PreferenceStore | null): boolean {
  if (store === null) return false;
  try {
    return store.getItem(KEY) === SHOWN;
  } catch {
    return false;
  }
}

export function writeDayPlanShown(store: PreferenceStore | null, shown: boolean): void {
  if (store === null) return;
  try {
    store.setItem(KEY, shown ? SHOWN : HIDDEN);
  } catch {
    // A full or refused storage loses the memory of the choice, not the choice on screen.
  }
}
